/* eslint-disable no-case-declarations */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as Styles from '../../../SharedModules/StyleConstant/StyleConstant';

export const textCustomComparator = (filter, value, filterText) => {
  const filterTextLoweCase = filterText.trim().toLowerCase();
  const valueLowerCase = value.toString().trim().toLowerCase();
  switch (filter) {
    case 'contains':
      return valueLowerCase.indexOf(filterTextLoweCase) >= 0;
    case 'notContains':
      return valueLowerCase.indexOf(filterTextLoweCase) === -1;
    case 'equals':
      return valueLowerCase === filterTextLoweCase;
    case 'notEqual':
      return valueLowerCase !== filterTextLoweCase;
    case 'startsWith':
      return valueLowerCase.indexOf(filterTextLoweCase) === 0;
    case 'endsWith':
      const index = valueLowerCase.lastIndexOf(filterTextLoweCase);
      return (
        index >= 0 &&
        index === valueLowerCase.length - filterTextLoweCase.length
      );
    default:
      return false;
  }
};

export const KEY_TYPE_TABLE_HEAD = [
  {
    headerName: 'Key Type',
    field: 'codeValueVO.codeValue',
    sortable: true,
    suppressMenu: false,
    minWidth: 100,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
  },
  {
    headerName: 'Short Description',
    field: 'codeValueVO.shortDescription',
    minWidth: Styles.Width_280,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'textFieldComponent',
    cellRendererParams: {
      maxLength: 30,
    },
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
  },
  {
    headerName: 'Long Description',
    field: 'codeValueVO.longDescription',
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_280,
    resizable: false,
    filter: 'agTextColumnFilter',
    cellRenderer: 'textFieldComponent',
    cellRendererParams: {
      maxLength: 255,
    },
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
  },
];

export const CODE_VALUE_TABLE_HEAD = [
  {
  headerName: 'Index',
  field: 'index',
  valueGetter: 'node.rowIndex',
    hide: true, 
  sortable: false,
  filter: false,
  minWidth: 80,
  maxWidth: 100,
  cellStyle: {
    display: 'flex',
    alignItems: 'center',
    'border-right-color': Styles.BorderColor,
  },
},

  {
    headerName: 'Contact Type Cd',
    field: 'contactTypeCd',
    sortable: true,
    suppressMenu: false,
    minWidth: 80,
    maxWidth: 200,
    required: true,
    cellRenderer: 'textFieldComponent',
    cellRendererParams: {
      required: true,
      maxLength: 10,
    },
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
  },
  {
    headerName: 'Short Description',
    field: 'shortDescr',
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_220,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    cellRenderer: 'textFieldComponent',
    cellRendererParams: {
      maxLength: 30,
    },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
  },
  {
    headerName: 'Long Description',
    field: 'longDescr',
    sortable: true,
    suppressMenu: false,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    minWidth: Styles.Width_220,
    filter: 'agTextColumnFilter',
    cellRenderer: 'textFieldComponent',
    cellRendererParams: {
      maxLength: 255,
    },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
  },
  {
    headerName: 'Display Sequence',
    field: 'dispSeq',
    minWidth: 3,

    maxWidth: 200,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    cellRenderer: 'textFieldComponent',
    cellRendererParams: {
      type: 'number',
      textAlign: 'right',
      maxLength: 3,
    },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
  },
  {
    headerName: 'Actions',
    cellRenderer: 'deleteBoxRenderer',
    filter: false,
    sortable: false,
    suppressMenu: false,
    resizable: false,
    minWidth: 100,
    maxWidth: 100,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    pdfExportOptions: {
      skipColumn: true,
    },
  },
];
